import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';

let xDown = null;
let yDown = null;

class Poem extends Component {
  state = {
    verticalAlignment: 'center',
  };

  componentDidMount() {
    if (this.contentEl) {
      this.startTimeout = setTimeout(() => {
        if (this.contentEl.offsetHeight > window.innerHeight - 80) {
          this.setState({
            verticalAlignment: 'start',
          });
        }
      }, 50);
    }
    document.addEventListener('touchstart', this.handleTouchStart, false);
    document.addEventListener('touchmove', this.handleTouchMove, false);
  }

  componentWillUnmount() {
    document.removeEventListener('touchstart', this.handleTouchStart, false);
    document.removeEventListener('touchmove', this.handleTouchMove, false);
  }

  handleTouchStart = (evt) => {
    const firstTouch = evt.touches[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
  }

  handleTouchMove = (evt) => {
    const { goToNext, goToPrev } = this.props;
    if (!xDown || !yDown) {
      return;
    }

    const xUp = evt.touches[0].clientX;
    const yUp = evt.touches[0].clientY;

    const xDiff = xDown - xUp;
    const yDiff = yDown - yUp;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      if (xDiff > 0) {
        goToNext();
      } else {
        goToPrev();
      }
    }
    xDown = null;
    yDown = null;
  }

  render() {
    const { stanzas } = this.props;
    const { verticalAlignment } = this.state;

    return (
      <div className={styles.wrapper} style={{ alignItems: verticalAlignment }}>
        <div
          className={styles.content}
          ref={el => {
            this.contentEl = el;
          }}
        >
          {stanzas &&
            stanzas.map(({ alignment, text }, i) => (
              <div
                dangerouslySetInnerHTML={{
                  __html: text.childMarkdownRemark.html,
                }}
                style={{ textAlign: alignment || 'left' }}
                key={`parent${i}`}
              />
            ))}
        </div>
      </div>
    );
  }
}

Poem.propTypes = {
  goToNext: PropTypes.func.isRequired,
  goToPrev: PropTypes.func.isRequired,
  stanzas: PropTypes.array.isRequired,
};

export default Poem;



// WEBPACK FOOTER //
// ./src/components/Poem/index.jsx